import { useState, useEffect } from "react";
import { X, Gift, Clock, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import CountdownTimer from "@/components/CountdownTimer";

const EngagementBanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if already dismissed in this session
    const dismissed = sessionStorage.getItem("bannerDismissed");
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Show after 2 seconds for immediate engagement
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    sessionStorage.setItem("bannerDismissed", "true");
  };

  if (isDismissed || !isVisible) return null;

  return (
    <div className="fixed top-16 left-0 right-0 z-40 animate-slide-up">
      <div className="bg-gradient-to-r from-primary via-accent to-primary py-2 px-4">
        <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-primary-foreground">
          <div className="flex items-center gap-2">
            <Gift className="h-4 w-4 flex-shrink-0 animate-pulse" />
            <span className="text-xs md:text-sm font-medium">
              <span className="hidden md:inline">🎁 Limited Offer: </span>
              <strong>Free Site Visit + ₹50,000 Off</strong>
              <span className="hidden md:inline"> on bookings this week!</span>
            </span>
          </div>
          <div className="flex items-center gap-2">
            <Button
              size="sm"
              variant="secondary"
              className="h-7 text-xs px-3 rounded-full font-semibold"
              asChild
            >
              <a href="tel:8297978080">
                <Phone className="h-3 w-3 mr-1" />
                Claim Now
              </a>
            </Button>
            <Button
              variant="ghost"
              size="icon"
              className="h-6 w-6 text-primary-foreground/80 hover:text-primary-foreground hover:bg-white/20 flex-shrink-0"
              onClick={handleDismiss}
              aria-label="Dismiss banner"
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EngagementBanner;
